import { DriverInvoiceOutput } from '@allocab/allocab-driver-shared-types';

import { PrimaryButton } from '../../components/button/PrimaryButton';
import { useDownloadInvoice } from '../../hooks/useDownloadInvoice';
import { t } from '../../services/translation/translation';

type Props = {
  invoice: DriverInvoiceOutput;
};

export const InvoiceDownloadButton = ({ invoice }: Props) => {
  const { mutate: downloadInvoice, isLoading } = useDownloadInvoice();

  return (
    <PrimaryButton
      text={t('common.download')}
      className="mr-0 ml-auto"
      onClick={() => downloadInvoice(invoice)}
      isLoading={isLoading}
    />
  );
};
